import React from "react";
import { roboticCodingServiceData } from "../../data/services-data";
import SEO from "../../components/SEO";
import seoData from "../../data/seoData";
const ServiceDetailsInner = React.lazy(() =>
  import("../../components/ServiceDetailsInner")
);

const RoboticCodingServiceDetailPage = () => {
  const data = roboticCodingServiceData;
  return (
    <>
      <SEO {...seoData.roboticCoding} />
      <ServiceDetailsInner data={data} />
    </>
  );
};

export default RoboticCodingServiceDetailPage;
